<!-- eslint-disable vue/no-mutating-props -->
<template>

 


<div class="nk-block-head">
  <div class="nk-block-head-content">
    <h5 class="nk-block-title" v-if="formIslem === 'ekle'">Yeni Görüşme Bilgi  Ekle</h5>
    <h5 class="nk-block-title" v-if="formIslem === 'duzenle'">Görüşme Bilgi  Düzenleme</h5>
    <div class="nk-block-des"><p>Görüşme Bilgiler</p></div>
  </div>
</div>

 

<div class="profile-ud-list">
                                                

                                                <div class="profile-ud-item">
                                                                    <div class="profile-ud wider"><span class="profile-ud-label">Etkinlik </span><span class="profile-ud-value">{{ localFormData.etkinlik_ad }}</span></div>
                                                                </div>
                                                                <div class="profile-ud-item">
                                                                    <div class="profile-ud wider"><span class="profile-ud-label">Firma </span><span class="profile-ud-value">{{ localFormData.firma_ad }}</span></div>
                                                                </div>
                                                                <div class="profile-ud-item">
                                                                    <div class="profile-ud wider"><span class="profile-ud-label">Firma Yetkilisi</span><span class="profile-ud-value">{{ localFormData.kisi_ad }}</span></div>
                                                                </div>
                                                
                                                                <div class="profile-ud-item">
                                                                    <div class="profile-ud wider"><span class="profile-ud-label">Görüşme Yapan</span><span class="profile-ud-value">{{ localFormData.gorusmeyapan_ad }}</span></div>
                                                                </div>
                                                <div class="profile-ud-item">
                                                                    <div class="profile-ud wider"><span class="profile-ud-label">Öncelik </span><span class="profile-ud-value">
                                                                        <template v-if="localFormData.oncelik =='onemli'" >Önemli </template>  
                                                                        <template v-if="localFormData.oncelik =='normal'" >Normal</template>  
                                                                        <template v-if="localFormData.oncelik =='takipet'" >Takip Et</template>  

                                                                    </span></div>
                                                                </div>
                                    
                                                                <div class="profile-ud-item">
                                                                <div class="profile-ud wider">
                                                                    <span class="profile-ud-label">Ziyaretçi Tipi</span>
                                                                    <span class="profile-ud-value">
                                                                        <template v-if="localFormData.ziyaretcitipi == 'sonkullanici'">Son Kullanıcı</template>
                                                                        <template v-if="localFormData.ziyaretcitipi == 'tedarikci'">Tedarikçi</template>
                                                                        <template v-if="localFormData.ziyaretcitipi == 'potansiyelbayi'">Potansiyel Bayi</template>
                                                                    </span>
                                                                </div>
                                                            </div>

                                    
                                                            <div class="profile-ud-item">
                                                            <div class="profile-ud wider">
                                                                <span class="profile-ud-label">Aktivite Tipi</span>
                                                                <span class="profile-ud-value">
                                                                    <template v-if="localFormData.aktivitetipi === 'acil'">Acil</template>
                                                                    <template v-if="localFormData.aktivitetipi === 'olagan'">Olağan</template>
                                                                </span>
                                                            </div>
                                                        </div>

                                    
                                                <div class="profile-ud-item">
                                                                    <div class="profile-ud wider"><span class="profile-ud-label">Malzeme Alt Yapı </span><span class="profile-ud-value">
                                                                      <template v-if="localFormData.lazer" >Lazer , </template>  
                                                                      <template v-if="localFormData.plazma" >Plazma , </template>  
                                                                      <template v-if="localFormData.oksijen" >Oksijen , </template>  
                                                                      <template v-if="localFormData.punch" >Punch , </template>  
                                                                      <template v-if="localFormData.diger" >Diğer  </template>  
                                                                    
                                                                    </span></div>
                                                                </div>
                                    
                                                <div class="profile-ud-item">
                                                                    <div class="profile-ud wider"><span class="profile-ud-label">Taşlama Personel Sayısı </span><span class="profile-ud-value">{{ localFormData.taslamapersonelsayi }}</span></div>
                                                                </div>
                                    
                                                <div class="profile-ud-item">
                                                                    <div class="profile-ud wider"><span class="profile-ud-label">Malzeme Kalınlığı Aralığı </span><span class="profile-ud-value">{{ localFormData.malzemekalinligiaraligi }}</span></div>
                                                                </div>
                                    
                                                <div class="profile-ud-item">
                                                                    <div class="profile-ud wider"><span class="profile-ud-label">Malzeme Genişlik Aralığı </span><span class="profile-ud-value">{{ localFormData.malzemegenislikaraligi }}</span></div>
                                                                </div>
                                    
                                                <div class="profile-ud-item">
                                                                    <div class="profile-ud wider"><span class="profile-ud-label">Malzeme Kalitesi </span><span class="profile-ud-value">{{ localFormData.malzemekalitesi }}</span></div>
                                                                </div>
                                    
                                                <div class="profile-ud-item">
                                                                    <div class="profile-ud wider"><span class="profile-ud-label">Malzeme Şekli </span><span class="profile-ud-value">{{ localFormData.malzemesekli }}</span></div>
                                                                </div>
                                    
                                                <div class="profile-ud-item">
                                                                    <div class="profile-ud wider"><span class="profile-ud-label">Tutucu Sistem </span><span class="profile-ud-value">{{ localFormData.tutucusistem }}</span></div>
                                                                </div>
                                    
                                                <div class="profile-ud-item">
                                                                    <div class="profile-ud wider"><span class="profile-ud-label">Doğrultma Makinesi Malzeme Kalınlık Aralığı </span><span class="profile-ud-value">{{ localFormData.dogrultmamalzemekalinlikaraligi }}</span></div>
                                                                </div>
                                    
                                                <div class="profile-ud-item">
                                                                    <div class="profile-ud wider"><span class="profile-ud-label">Doğrultma Maksimum Parça Genişliği </span><span class="profile-ud-value">{{ localFormData.dogrultmamaksimumparcagenisligi }}</span></div>
                                                                </div>
                                    
                                                <div class="profile-ud-item">
                                                                    <div class="profile-ud wider"><span class="profile-ud-label">Doğrultma Makinesi Maksimum Malzeme Boyu </span><span class="profile-ud-value">{{ localFormData.dogrultmamaksimummalzemeboyu }} {{ localFormData.dogrultmamaksimummalzemeboyuolcu }}</span></div>
                                                                </div>
                                    
                                                <div class="profile-ud-item">
                                                                    <div class="profile-ud wider"><span class="profile-ud-label">Doğrultma Makinesi Aranılan Düzlemsellik Toleransı </span><span class="profile-ud-value">{{ localFormData.dogrultmaaranilanduzlemselliktoleransi }} {{ localFormData.dogrultmamaksimummalzemeboyuolcu }}</span></div>
                                                                </div>
                                    
                                    
                                    <div class="profile-ud-item">
                                                                    <div class="profile-ud wider"><span class="profile-ud-label">Manuel Çapak Alma ve Kaner Yuvarlama Makinesi Noti  </span><span class="profile-ud-value">{{ localFormData.manuelcapakalmavekenaryuvarlamamakinesinot }}</span></div>
                                                                </div>
                                    
                                    <div class="profile-ud-item">
                                                                    <div class="profile-ud wider"><span class="profile-ud-label">Not </span><span class="profile-ud-value">{{ localFormData.not }}</span></div>
                                                                </div>
                                    
                                    <div class="profile-ud-item">
                                                                    <div class="profile-ud wider"><span class="profile-ud-label">Ses Kaydi </span><span class="profile-ud-value">   <audio :src="$globalVariable.uploadUrl +localFormData.seskaydi" controls></audio></span></div>
                                                                </div>

                                                                <div class="profile-ud-item">
                                                                    <div class="profile-ud wider"><span class="profile-ud-label">Kartvizit Görsel Ön </span><span class="profile-ud-value">     <img 
    v-if="localFormData.kartviziton" 
    class="rounded img-cover mb-2 h-50" 
    :src="$globalVariable.uploadUrl + localFormData.kartviziton" 
    alt="Kartvizit Ön Görsel" 
  /></span></div>
                                                                </div>

                                                                <div class="profile-ud-item">
                                                                    <div class="profile-ud wider"><span class="profile-ud-label">Kartvizit Görsel Arka </span><span class="profile-ud-value">     <img 
    v-if="localFormData.kartvizitarka" 
    class="rounded img-cover mb-2 h-50" 
    :src="$globalVariable.uploadUrl + localFormData.kartvizitarka" 
    alt="Kartvizit Ön Görsel" 
  /></span></div>
                                                                </div>
                                    

                                    
                               
                                    <div class="profile-ud-item">
                                                                    <div class="profile-ud wider"><span class="profile-ud-label">Tarih </span><span class="profile-ud-value">{{ localFormData.tarih }}</span></div>
                                                                </div>
                                    
                                                 
                                                    

                                            </div>
      

    


 

    <div class="d-flex justify-content-around  mt-4"> 
      
      <button type="button" class="btn btn-light  mr-2" @click="iptalEt"><em class="icon ni ni-cross"></em><span>İptal Et</span></button>
      <button type="submit" class="btn btn-primary"><em class="icon ni ni-check"></em><span>Kaydet</span></button>
    </div>


</template>

<script>
import axiosCustom from "@/services/axiosCustom";







export default {
components: {
  
  
},
props: {
  formIslem: String,
  formData: Object,
  formKaydetSonrasi: Function,
  formIptal: Function,

},
data() {
  return {
    
    kartvizitonSecili: null,
    
    kartvizitarkaSecili: null,
    
    
  firmalar: [],
  
  etkinlikler: [],
  
  kisiler: [],
  
  kullanicilar: [],
  
  

  
    localFormData: { ...this.formData }, 
    formHatalar:{},

    

  };
},
created() {
  
  this.firmalarGetir();
  
  this.etkinliklerGetir();
  
  this.kisilerGetir();
  
  this.kullanicilarGetir();
  
   

  
},
watch: {
      formData: {
        handler(newFormData) {
          this.localFormData = { ...newFormData };

  
          
          if(this.localFormData.agircapakalma=='1'){
            this.localFormData.agircapakalma=true;
            }else{
              this.localFormData.agircapakalma=false;
            }
          
          if(this.localFormData.yuzeycapakalma=='1'){
            this.localFormData.yuzeycapakalma=true;
            }else{
              this.localFormData.yuzeycapakalma=false;
            }
          
          if(this.localFormData.kenaryuvarlama=='1'){
            this.localFormData.kenaryuvarlama=true;
            }else{
              this.localFormData.kenaryuvarlama=false;
            }
          
          if(this.localFormData.satine=='1'){
            this.localFormData.satine=true;
            }else{
              this.localFormData.satine=false;
            }
          
          if(this.localFormData.polisaj=='1'){
            this.localFormData.polisaj=true;
            }else{
              this.localFormData.polisaj=false;
            }
          
          if(this.localFormData.oksitkaldirma=='1'){
            this.localFormData.oksitkaldirma=true;
            }else{
              this.localFormData.oksitkaldirma=false;
            }
          
          if(this.localFormData.hizliekleme=='1'){
            this.localFormData.hizliekleme=true;
            }else{
              this.localFormData.hizliekleme=false;
            }
          
          
          
         
          
        },
        immediate: true, // Component oluşturulduğunda da tetikle
      },
    },
methods: {
  
  async firmalarGetir() {
    try {
      const response = await axiosCustom.get("firmalar"); 
      this.firmalar = response.data;
    } catch (error) {
      console.error("firmalar alma hatası: ", error);
    }
  },
  
  async etkinliklerGetir() {
    try {
      const response = await axiosCustom.get("etkinlikler"); 
      this.etkinlikler = response.data;
    } catch (error) {
      console.error("etkinlikler alma hatası: ", error);
    }
  },
  
  async kisilerGetir() {
    try {
      const response = await axiosCustom.get("kisiler"); 
      this.kisiler = response.data;
    } catch (error) {
      console.error("kisiler alma hatası: ", error);
    }
  },
  
  async kullanicilarGetir() {
    try {
      const response = await axiosCustom.get("kullanicilar"); 
      this.kullanicilar = response.data;
    } catch (error) {
      console.error("kullanicilar alma hatası: ", error);
    }
  },
  
  



 

  

    
},
};
</script>